import React from 'react';
import { AlertCircle } from 'lucide-react';
export function PainPoints() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-135">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-136">
        <div className="text-center mb-12" data-id="element-137">
          <h2 className="font-serif text-3xl md:text-4xl text-[#2D2A26] mb-4" data-id="element-138">
            Lo que probablemente te está pasando <br data-id="element-139" />
            <span className="text-[#C4705A] italic" data-id="element-140">(y casi nadie dice)</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-141">
          <div className="space-y-6 text-lg text-[#2D2A26]/80 leading-relaxed" data-id="element-142">
            <p data-id="element-143">
              Hay un tipo de dolor que no llega con un golpe.
              <span className="block font-semibold text-[#2D2A26] mt-1" data-id="element-144">
                Llega con el día.
              </span>
            </p>
            <p data-id="element-145">Con:</p>
            <ul className="space-y-3" data-id="element-146">
              <li className="flex items-start gap-3" data-id="element-147">
                <div className="w-1.5 h-1.5 rounded-full bg-[#C4705A] mt-2.5 flex-shrink-0" data-id="element-148" />
                <span data-id="element-149">El teléfono un poco más abajo de lo que debería</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-150">
                <div className="w-1.5 h-1.5 rounded-full bg-[#C4705A] mt-2.5 flex-shrink-0" data-id="element-151" />
                <span data-id="element-152">Los hombros un poco más arriba de lo normal</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-153">
                <div className="w-1.5 h-1.5 rounded-full bg-[#C4705A] mt-2.5 flex-shrink-0" data-id="element-154" />
                <span data-id="element-155">El estrés apretado en la mandíbula</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-156">
                <div className="w-1.5 h-1.5 rounded-full bg-[#C4705A] mt-2.5 flex-shrink-0" data-id="element-157" />
                <span data-id="element-158">Horas "aguantando" sin darte cuenta</span>
              </li>
            </ul>
            <p className="font-medium text-[#2D2A26] border-l-4 border-[#C4705A] pl-4 italic" data-id="element-159">
              Y cuando por fin paras… tu cuerpo cobra.
            </p>
          </div>

          <div className="bg-[#FAF8F5] p-8 rounded-2xl border border-[#C4705A]/10" data-id="element-160">
            <div className="flex items-start gap-4 mb-6" data-id="element-161">
              <AlertCircle className="w-8 h-8 text-[#C4705A] flex-shrink-0" data-id="element-162" />
              <h3 className="font-serif text-xl font-bold text-[#2D2A26]" data-id="element-163">
                El problema no es tu fuerza. <br data-id="element-164" />
                Es tu falta de resets.
              </h3>
            </div>

            <p className="text-[#2D2A26]/70 mb-4" data-id="element-165">La mayoría intenta:</p>
            <ul className="space-y-3 text-[#2D2A26]/80 mb-6" data-id="element-166">
              <li className="flex items-start gap-2" data-id="element-167">
                <span className="text-[#C4705A] font-bold" data-id="element-168">×</span>
                <span data-id="element-169">Estirar cuando ya está demasiado tensa</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-170">
                <span className="text-[#C4705A] font-bold" data-id="element-171">×</span>
                <span data-id="element-172">Hacer una rutina larga un día y luego nada</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-173">
                <span className="text-[#C4705A] font-bold" data-id="element-174">×</span>
                <span data-id="element-175">Copiar ejercicios genéricos que a veces empeoran</span>
              </li>
            </ul>

            <p className="text-sm font-medium text-[#2D2A26]" data-id="element-176">
              Eso no falla por falta de ganas. <br data-id="element-177" />
              Falla porque{' '}
              <span className="underline decoration-[#C4705A]/30 decoration-2" data-id="element-178">
                no está diseñado para una mujer ocupada
              </span>
              .
            </p>
          </div>
        </div>
      </div>
    </section>;
}